(function ($) {


   $(window).on('load',function () {
        if($(' .col-four-slider').length>0) {
            setTimeout(function () {
                $(".col-four-slider .row-wrap").css({"opacity":"1"});
            },500);
            $('.col-four-slider .text-wrap h6').matchHeight();
        }
            $(' .col-four-slider').each(function () {
                var slider=$(this);
                if(!$(this).hasClass('two-card-slider')) {
                    setSlider(slider,4);
                    $(this).find('.text-wrap').matchHeight({byRow: false});
                }
                else {
                    $(this).find('.col-four').each(function () {
                        var date=$(this).find('.date').clone();
                        $(this).find('.date').remove();
                        $(this).find('.text-wrap').append(date);

                        var content=$(this).find('.content-wrap').clone();
                        $(this).find('.content-wrap').remove();
                        $(this).find('.text-wrap').append(content);
                        $(this).find('.text-wrap').wrap('<div class="outer-wrapper"></div>');
                    });
                    setSlider(slider,2);
                }
            });


       videoOverlay();

       $('.col-four-slider').siblings('.img-overlay').addClass('four-col-overlay');
       function videoOverlay() {
           $(document).on('click', '.col-four-slider .img-outer a', function (e) {
               e.preventDefault();
               e.stopPropagation();
               $('.col-four-slider .col-four').removeClass('active');
               $(this).parents('.col-four').addClass('active');
               $(this).siblings(".img-wrapper").clone().appendTo(".img-overlay .img-box .img-container");
               $('body').addClass('overlay-active');
               $(".img-overlay").addClass("img-active");
           });
           closeVideoOverlay();
       }

       function closeVideoOverlay() {
           $('.closeVideo').on('click', function () {
               $('body').removeClass('overlay-active');
               $('.col-four-slider .col-four').removeClass('active');
               $('.img-overlay').removeClass("img-active");
               $(".img-overlay .img-box .img-container .img-wrapper").remove();
           });

           // Close video overlay on outside click
           $('.img-overlay .v-middle-inner').on('click', function () {
               $('body').removeClass('overlay-active');
               $('.col-four-slider .col-four').removeClass('active');
               $('.img-overlay').removeClass("img-active");
               $(".img-overlay .img-box .img-container .img-wrapper").remove();
           });
       }
       if($(window).width()<1200) {
       $(".col-four-slider .text-wrap h6").dotdotdot({
           height: 60,
           fallbackToLetter: true,
           watch: true,
       });
       }

   });

    $(window).on('load resize orientationchange',function () {
        $('.col-four-slider .row-wrap').slick('resize');

    });




       function setSlider(slider,slides) {
           var slide=slider;
           var numSlides=slides;

           var tablet,tabletDown,phabletDown;
           if(numSlides==2) {
               tablet=2;
               tabletDown=1;
               phabletDown=1;
           }
           else if(numSlides==4) {
               tablet=3;
               tabletDown=2;
               phabletDown=1;
           }
           slide.find('.row-wrap').not('.slick-initialized').slick({
               slidesToShow: numSlides,
               slidesToScroll: 1,
               dots: false,
               arrows: true,
               infinite: false,
               cssEase: 'linear',
               responsive: [
                   {
                       breakpoint: 1024,
                       settings: {
                           slidesToShow: tablet
                       }
                   },
                   {
                       breakpoint: 767,
                       settings: {
                           slidesToShow: tabletDown,
                           draggable: true
                       }
                   },
                   {
                       breakpoint: 595,
                       settings: {
                           slidesToShow: phabletDown,
                           draggable: true
                       }
                   }
               ]
           });


       }


})(jQuery);
